import fallInLoveImg from "@/assets/night-hot-tub.png.asset.json";
import familyAdventureImg from "@/assets/family-promo.jpg.asset.json";

export type Offer = {
  id: string;
  badge: string;
  title: string;
  subtitle: string;
  body: string;
  offerIntro: string;
  bonusValue: string;
  bonusDetails: string[];
  bonusCopy: string;
  scarcity: string;
  code: string;
  bestFor: string;
  ctaLabel: string;
  fineprint: string;
  image: string;
  teaser: string;
};

export const OFFER_IMAGES = { fallInLoveImg: fallInLoveImg.url, familyAdventureImg: familyAdventureImg.url };


export const OFFERS: Offer[] = [
  {
    id: "fall-in-love",
    badge: "Couples Offer",
    title: "Fall in Love",
    subtitle: "A romantic escape, made effortless.",
    body: "Slip away to cool mountain air, quiet forest nights, and time that feels entirely your own. Soak under the stars, linger over dinner, and let Backland turn a simple escape into something intimate, memorable, and effortless.",
    offerIntro: "Book two or more nights to receive:",
    bonusValue: "$275",
    bonusDetails: [
      "Romance Package included ($175 value)",
      "$100 off the Stay & Dine rate",
    ],
    bonusCopy:
      "We'll help create the mood before you arrive with the Backland Romance Package included in your stay, plus $100 off the Stay & Dine rate.",
    scarcity:
      "With only 10 suites, romantic getaway dates often book quickly.",
    code: "FALLINLOVE",
    bestFor:
      "Anniversaries, birthdays, proposals, romantic getaways, or a much-needed reset together.",
    ctaLabel: "Book Fall in Love",
    fineprint:
      "Applies to the Stay & Dine rate only. 2-night minimum. Subject to availability. Cannot be combined with other offers.",
    image: fallInLoveImg.url,
    teaser: "Book two or more nights and get:",
  },
  {
    id: "family-adventure",
    badge: "Family Offer",
    title: "Family Adventure Package",
    subtitle: "A wilder escape for the whole family.",
    body: "Give the family room to roam, breathe, and reconnect in the cool mountain air. Spend the day by the pond, around the campfire, or exploring nearby wonders, then settle into a spacious nature suite made for slow nights together.",
    offerIntro: "Book two or more nights to receive:",
    bonusValue: "$200",
    bonusDetails: [],
    bonusCopy:
      "$200 off the Stay & Dine rate.",
    scarcity:
      "With only 10 suites, availability can disappear quickly during school breaks and Grand Canyon travel season.",
    code: "ADVENTUREFAM",
    bestFor:
      "Family adventures, Grand Canyon trips, school breaks, birthdays, and last-minute escapes.",
    ctaLabel: "Book Family Adventure",
    fineprint:
      "Applies to the Stay & Dine rate only. 2-night minimum. Subject to availability. Cannot be combined with other offers.",
    image: familyAdventureImg.url,
    teaser: "Book two or more nights and get:",
  },
];

export const INTEREST_OPTIONS = [
  "Couples Getaways",
  "Family Trips",
  "Grand Canyon",
  "Events & Groups",
  "Dining",
  "Stargazing",
] as const;
